import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  children: React.ReactNode;
  className?: string;
}
export function Button({
  variant = 'primary',
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-6 py-3 text-sm font-medium transition-all duration-300 rounded-full whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-white/20 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-white text-zinc-950 hover:bg-zinc-200 hover:scale-[1.02] active:scale-[0.98]',
    secondary: 'glass-panel hover:bg-white/10 text-white hover:scale-[1.02] active:scale-[0.98]',
    ghost: 'text-zinc-400 hover:text-white hover:bg-white/5'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-248">
      {children}
    </button>;
}